// @ts-check
/**
 * Check if the given error is a `fetch` network error
 * @type {(error: Error) => boolean}
 */
export const isNetworkError = (error) =>
  error instanceof TypeError && error.message === "Failed to fetch";

export const isOfflineError = (error) => isNetworkError(error) && !window.navigator.onLine;
